import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { FormTranslation } from "./navigation-entities/FormTranslation.model";


export class Form extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  description!: string;

  numero?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NavigationProperty({ TargetType: FormTranslation })
  formTranslations?: FormTranslation[];

  GetType(): IEntityMetaData {
    return Form.getMetaData();
  }
}
